import React from 'react';
import type { LineProps } from 'Cms/product-price-ticket-custom/resolver';
import 'Cms/product-price-ticket-custom/resolver';
import { getPriceTicketSubtitle } from 'Components/widgets/price-ticket/priceTicket.mapper';
import { usePageContext } from 'Context/PageContext';
import { addTranslationKeys } from 'Src/i18n';
import { PriceTicketContentWrapper } from 'Components/widgets/price-ticket/PriceTicketContentWrapper';
export const ProductPriceTicketCustom = ({
  config,
  getAQuoteCTA,
  getAQuoteURL,
  resort,
}: LineProps) => {
  const { pageType } = usePageContext();
  addTranslationKeys({
    ...config,
    productPriceTicketMiceLine: {
      getAQuoteCTA,
      getAQuoteURL,
    },
  });
  const priceTicketContentProps = {
    button: {
      children: getAQuoteCTA,
      trackingData: {
        actionGA: 'priceBar',
        categoryGA: pageType,
        labelGA: 'getAQuote',
      },
      url: getAQuoteURL,
    },
    fromPriceTicketCustom: true,
    price: resort.mice,
    subtitle: getPriceTicketSubtitle(resort),
    title: resort.name,
  };
  return (
    <div className="Line Line-PriceTicketCustom relative z-3">
      <PriceTicketContentWrapper {...priceTicketContentProps} />
    </div>
  );
};
